<div class="slide-toggle">
  <div class="switch" [ngClass]="{'left': labelPosition === 'left', 'small': size === 'small'}">
    <input type="checkbox" id="checkbox" (change)="onInputChange($event)" [checked]="value" />
    <label for="checkbox"></label>
  </div>
  <label for="checkbox" class="label" [ngClass]="{'left': labelPosition === 'left', 'small-switch': size === 'small'}">{{labelText}}</label>
</div>
